export class PaymentMethod
{
	id = "";
	isInstant: boolean;
	name = "";
}


// WEBPACK FOOTER //
// ./src/models/PaymentMethod.ts